import MathCalculations from "./MathCalculations";
import Conjugation from "./Conjugation";
import Dictation from "./Dictation";

export default {
  mathCalculations: MathCalculations,
  conjugation: Conjugation,
  dictation: Dictation,
};
